import LoaderBalls from 'components/LoaderBalls'
import React from 'react'
import { useSelector } from 'react-redux'

import './style.css'

const ChatLoader = () => {
  const chatOpen = useSelector(state =>
    state.view.chatOpen
  )

  return (
    <div className="drift-widget-chat-layout-loader">
      <LoaderBalls className="drift-widget-chat-layout-loader--loader-balls" visible={chatOpen} titleId="ChatLoader" />
    </div>
  )
}

export default ChatLoader
